import { jsonMember, jsonObject } from 'typedjson';
import { Nillable } from '@web/utils';

@jsonObject
export class DictionaryUpdateRequest {
  @jsonMember(String)
  public label!: string;

  @jsonMember(String)
  public slug?: Nillable<string>;

  @jsonMember(Number)
  public position!: number;

  public constructor(
    private readonly data: {
      label: string;
      position: number;
      slug?: Nillable<string>;
    },
  ) {
    this.label = this.data.label;
    this.position = this.data.position;
    this.slug = this.data.slug;
  }
}
